<template>
    <ul class="pagination no-margin-top">
        <li>
                <span
                        class="page-numbers"
                        @click="onClickFirstPage"
                        v-if="!isInFirstPage"
                        aria-label="Go to first page"
                >
                    Inizio
                </span>
        </li>
        <li>
                <span
                        class="page-numbers"
                        @click="onClickPreviousPage"
                        v-if="!isInFirstPage"
                        aria-label="Go to previous page"
                >
                    &lt;
                </span>
        </li>
        <li v-for="page in pages"
            v-bind:class="[isPageActive(page.name)  ? 'active' : '']"
        >
                    <span
                            v-bind:class="[isPageActive(page.name)  ? 'page-numbers active' : 'page-numbers']"
                            @click="onClickPage(page.name)"
                            :aria-label="`Go to page number ${page.name}`"
                    >{{ page.name }}</span>
        </li>
        <li>
                <span
                        class="page-numbers"
                        @click="onClickNextPage"
                        v-if="!isInLastPage"
                        aria-label="Go to next page"
                >
                    &gt;
                </span>
        </li>
        <li>
                <span
                        class="page-numbers"
                        @click="onClickLastPage"
                        v-if="!isInLastPage"
                        aria-label="Go to last page"
                >
                    Fine
                </span>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'pagination',
        props: {
            maxVisibleButtons: {
                type: Number,
                required: false,
                default: 10
            },
            totalPages: {
                type: Number,
                required: true
            },
            total: {
                type: Number,
                required: true
            },
            perPage: {
                type: Number,
                required: true
            },
            currentPage: {
                type: Number,
                required: true
            },
        },
        computed: {
            startPage() {
                if (this.currentPage === 1) {
                    return 1;
                }

                if (this.currentPage === this.totalPages) {
                    let startPage = this.totalPages - this.maxVisibleButtons + 1;

                    if (startPage < 1) {
                        return 1;
                    }
                    return startPage;
                }

                return this.currentPage - 1;

            },
            endPage() {
                return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
            },
            pages() {
                const range = [];

                for (let i = this.startPage; i <= this.endPage; i += 1) {
                    if (i > 0) {
                        range.push({
                            name: i,
                            isDisabled: i === this.currentPage
                        });
                    }

                }

                return range;
            },
            isInFirstPage() {
                return this.currentPage === 1;
            },
            isInLastPage() {
                return this.currentPage === this.totalPages;
            },
        },
        methods: {
            onClickFirstPage() {
                this.$emit('pagechanged', 1);
            },
            onClickPreviousPage() {
                this.$emit('pagechanged', this.currentPage - 1);
            },
            onClickPage(page) {
                this.$emit('pagechanged', page);
            },
            onClickNextPage() {
                this.$emit('pagechanged', this.currentPage + 1);
            },
            onClickLastPage() {
                this.$emit('pagechanged', this.totalPages);
            },
            isPageActive(page) {
                return this.currentPage === page;
            },
        }
    }
</script>

<style scoped>

</style>
